{
  "cancellation": {
    "confirmationTitle": "Annuler l'abonnement",
    "confirmationBodyOne": "Êtes-vous sûr de vouloir annuler votre abonnement",
    "confirmationBodyTwo": "Vous n'aurez plus accès à votre compte et à vos données après l'expiration de l'abonnement",
    "reasonHeadingOne": "Nous sommes désolés de vous voir partir.",
    "reasonHeadingTwo": "Nous aimerions avoir votre avis sur la manière d'améliorer Iventis.",
    "reasonSubheadingOne": "Quelle est la principale raison de l'annulation ?",
    "reasonSubheadingTwo": "Veuillez fournir tout commentaire supplémentaire",
    "reasonOne": "Je n'utilise pas complètement Iventis",
    "reasonTwo": "Je trouve que c'est difficile à utiliser",
    "reasonThree": "Il n'a pas la fonctionnalité que je recherche",
    "reasonFour": "C'est trop cher",
    "reasonFive": "J'ai décidé de passer à un autre produit",
    "reasonSix": "Autres",
    "addComment": "Ajouter un commentaire",
    "cancelSubscription": "Annuler l'abonnement",
    "reactivate": "Réactivez votre abonnement",
    "success": "Votre abonnement a été annulé et expirera le",
    "error": "Un problème est survenu lors de l'annulation de votre abonnement. Veuillez contacter le support.",
    "successReactivate": "Votre projet a été réactivé",
    "errorReactivate": "Un problème est survenu lors de la réactivation de votre abonnement. Veuillez contacter le support.",
    "contactUs": "Contacter le support",
    "nonAutomatedCancel": "Veuillez contacter le support pour annuler votre abonnement",
    "nonAutomatedReactivate": "Veuillez contacter le support pour réactiver votre abonnement",
    "cancelsOn": "Annule le",
    "keepSubscription": "Maintenir l'abonnement"
  },
  "limits": {
    "limitedResource": {
      "IndividualMap": "plans",
      "TeamMap": "plans",
      "User": "utilisateurs"
    },
    "out_of": "{{ current }} sur {{ maximum }} actifs {{ resources }}",
    "users": {
      "limitReached": {
        "title": "Limite d'utilisateurs atteinte",
        "content": "Vous avez atteint le nombre maximum d'utilisateurs pour ce projet. Pour ajouter d'autres utilisateurs, veuillez"
      },
      "limitRemaining": {
        "title": "Il reste 1 utilisateur",
        "content": "Vous êtes sur le point d'atteindre le nombre maximum d'utilisateurs pour ce projet. Pour ajouter d'autres utilisateurs"
      }
    },
    "custom_layer": {
      "title": "Effectuez une mise à niveau pour personnaliser votre couche",
      "content": "Passez à notre plan professionnel pour une personnalisation illimitée ou contactez-nous à l'adresse suivante :"
    }
  }
}